// extracted by mini-css-extract-plugin
module.exports = {"button":"BackBtn_button__32Hvk"};